import React from 'react';
import PropTypes from 'prop-types';

import {Box, Typography} from 'views/components';
import {Translate} from 'views/module';

const CareScheduleBox = (props) => {
  const {data} = props;

  return (
    <Box sx={{background: 'white', borderRadius: '1rem', boxShadow: '0 1px 6px rgba(0,0,0,0.1)', padding: '1rem', position: 'relative'}}>
      <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem'}}>
        <Typography variant="h6">
          <Translate expression="profile.CareScheduleBox.Title" />
        </Typography>
      </Box>

      {/* Schedule Title */}
      <Typography variant="subtitle2" style={{marginTop: 0}}>
        <Translate expression="profile.CareScheduleBox.Schedule" />
      </Typography>
      {
        data.schedule && (
          <Box sx={{padding: '0.5rem 0'}}>
            <Typography style={{whiteSpace: 'pre-line', color: '#374151', fontSize: 14}}>{data.schedule}</Typography>
          </Box>
        )
      }
      {
        !data.schedule && (
          <Typography style={{color: '#71717A', fontStyle: 'italic', fontSize: '0.875rem', padding: '0.5rem 0'}}>
            <Translate expression="profile.CareScheduleBox.SchedulePlaceholder" />
          </Typography>
        )
      }
    </Box>
  );
};

CareScheduleBox.propTypes = {
  data: PropTypes.shape({
    schedule: PropTypes.string,
  }).isRequired,
};

export default CareScheduleBox;
